(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell-popup"] && !Shopify.designMode) return;
  try {
    
  class UpsellPopupComponent extends HTMLElement {
    constructor() {
      super();
      this.dialog = null;
      this._pendingForm = null;
      this._skipNextIntercept = false;
      this._initialized = false;
    }

    connectedCallback() {
      // Wacht op de HTML parser om de children in te laden (bekende Custom Element quirk)
      if (!this.querySelector('.upsell-popup__dialog')) {
        setTimeout(() => this.connectedCallback(), 50);
        return;
      }
      
      if (this._initialized) return;
      this._initialized = true;
      
      this.dialog = this.querySelector('.upsell-popup__dialog');

      if (this.dialog.dataset.openInEditor === 'true') {
        setTimeout(() => this.openPopup(), 500); // 500ms delay ensures custom element is fully painted before dialog API trigger
      }

      
      // Slider navigation
      const productsContainer = this.querySelector('[data-upsell-products]');
      const btnPrev = this.querySelector('[data-upsell-prev]');
      const btnNext = this.querySelector('[data-upsell-next]');

      if (productsContainer && btnPrev && btnNext) {
        btnPrev.addEventListener('click', () => {
          const cardWidth = productsContainer.querySelector('[data-upsell-card]')?.clientWidth || 0;
          productsContainer.scrollBy({ left: -cardWidth, behavior: 'smooth' });
        });
        btnNext.addEventListener('click', () => {
          const cardWidth = productsContainer.querySelector('[data-upsell-card]')?.clientWidth || 0;
          productsContainer.scrollBy({ left: cardWidth, behavior: 'smooth' });
        });
      }

      // "Nee, bedankt" / close buttons — just close & submit original form
      this.querySelectorAll('[data-upsell-close]').forEach((btn) => {
        btn.addEventListener('click', () => this._closeAndSubmit());
      });

      // Confirm button — add selected upsells then close & submit
      const confirmBtn = this.querySelector('[data-upsell-confirm]');
      if (confirmBtn) {
        confirmBtn.addEventListener('click', () => this._handleConfirm(confirmBtn));
      }

      // Close on backdrop click
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this._closeAndSubmit();
      });

      // Native Escape key
      this.dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        this._closeAndSubmit();
      });

      // Intercept add-to-cart button clicks (capture phase, before theme JS)
      this._interceptAddToCart();

      // Card selection (click or keyboard)
      this.querySelectorAll('[data-upsell-card]').forEach((card) => {
        card.addEventListener('click', () => this._toggleCard(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            this._toggleCard(card);
          }
        });
      });

      // Variant selects: update card's variant-id + price display
      this.querySelectorAll('[data-upsell-variant-select]').forEach((select) => {
        select.addEventListener('click', (e) => e.stopPropagation()); // don't toggle card
        select.addEventListener('change', (e) => this._handleVariantChange(e));
      });
    }

    /* ── Add-to-cart interception ── */
    _interceptAddToCart() {
      document.addEventListener('click', (e) => {
        if (this._skipNextIntercept) return;

        // Match standard submit button OR the bundle builder desktop button OR the icon pictogram ATC button
        const addBtn = e.target.closest('[data-type="add-to-cart-form"] [name="add"], #bb-add-to-cart, #bb-mf-cta-btn, .icon-block__atc-btn');
        if (!addBtn) return;
        
        // Prevent intercept if disabled
        if (addBtn.disabled) return;

        // Don't re-intercept if popup already open
        if (this.dialog.hasAttribute('open')) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        // If an icon-block ATC button was clicked, update the dialog's main title
        // so the "Toegevoegd aan" cart property shows the correct product name.
        if (addBtn.classList.contains('icon-block__atc-btn') && addBtn.dataset.productTitle) {
          this.dialog.dataset.mainTitle = addBtn.dataset.productTitle;
        }

        // Save the target to execute after popup handles the upsell.
        const isBundleBtn = addBtn.id === 'bb-add-to-cart' || addBtn.id === 'bb-mf-cta-btn';
        let targetForm = addBtn.closest('[data-type="add-to-cart-form"]');
        if (!targetForm || isBundleBtn || addBtn.classList.contains('icon-block__atc-btn')) {
            targetForm = addBtn;
        }
        this._pendingForm = targetForm;

        this.openPopup();
      }, true); // capture so we run before theme listeners
    }

    /* ── Open / close ── */
    openPopup() {
      this.dialog.showModal();
      this.dialog.dataset.step = '1'; // Reset to step 1
      // Reset card selections: Select dummy card, deselect real cards
      this.querySelectorAll('[data-upsell-card]').forEach((c) => {
        const isDummy = !c.dataset.variantId;
        this._setCardSelected(c, isDummy);
      });
      // Clear custom fields
      this.querySelectorAll('.upsell-popup__custom-fields input, .upsell-popup__custom-fields textarea').forEach(el => el.value = '');
      // Focus first available card
      const firstCard = this.querySelector('[data-upsell-card][data-available="true"]');
      if (firstCard) setTimeout(() => firstCard.focus(), 50);
    }

    _closeAndSubmit() {
      this.dialog.close();
      this._submitPendingForm();
    }

    _submitPendingForm() {
      if (!this._pendingForm) return;
      const form = this._pendingForm;
      this._pendingForm = null;
      // Set flag so our click intercept ignores the programmatic requestSubmit
      this._skipNextIntercept = true;

      // Inject the generated bundle ID into the main form/button so they are linked
      if (this.dialog.dataset.bundleId) {
        if (form.tagName === 'FORM') {
          let bundleInput = form.querySelector('input[name="properties[_bundle_id]"]');
          if (!bundleInput) {
            bundleInput = document.createElement('input');
            bundleInput.type = 'hidden';
            bundleInput.name = 'properties[_bundle_id]';
            form.appendChild(bundleInput);
          }
          bundleInput.value = this.dialog.dataset.bundleId;
        } else {
          // If it's a button (like the pictogram ATC), we pass it via dataset
          form.dataset.bundleId = this.dialog.dataset.bundleId;
        }
      }

      // Execute the pending action (form submit or button click)
      if (form.id === 'bb-add-to-cart' || form.id === 'bb-mf-cta-btn') {
        // Bundle builder: call the BB API directly
        if (window.__bb && typeof window.__bb.addToCart === 'function') {
          window.__bb.addToCart();
        }
      } else if (form.tagName === 'BUTTON' || form.tagName === 'A') {
        form.click();
      } else if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
      setTimeout(() => { this._skipNextIntercept = false; }, 300);
    }

    /* ── Card selection ── */
    _toggleCard(card) {
      if (card.dataset.available === 'false') return;
      const isSelected = card.getAttribute('aria-checked') === 'true';

      // If we interact with the dummy card, we no longer auto-close.
      // We just let it be selected and let the user press the confirm button.

      // If we are selecting this card, deselect all others first
      if (!isSelected) {
        this.querySelectorAll('[data-upsell-card]').forEach((c) => {
          if (c !== card) {
            this._setCardSelected(c, false);
          }
        });
      }

      this._setCardSelected(card, !isSelected);
    }

    _setCardSelected(card, selected) {
      card.setAttribute('aria-checked', selected ? 'true' : 'false');
      card.classList.toggle('upsell-popup__product-card--selected', selected);
      this._updateCustomFieldsVisibility();
    }

    _updateCustomFieldsVisibility() {
      const selectedCards = [...this.querySelectorAll('[data-upsell-card][aria-checked="true"]')];
      const hasRealSelection = selectedCards.some(card => card.dataset.variantId && card.dataset.variantId.trim() !== '');
      
      const customFields = this.querySelector('.upsell-popup__custom-fields');
      if (customFields) {
        customFields.classList.toggle('is-visible', hasRealSelection);
      }
    }

    /* ── Variant change ── */
    _handleVariantChange(e) {
      const select = e.target;
      const card = select.closest('[data-upsell-card]');
      if (!card) return;

      const opt = select.options[select.selectedIndex];
      const available = opt.dataset.available === 'true';

      // Update card variant id
      card.dataset.variantId = opt.value;
      card.dataset.available = available;

      if (!available) this._setCardSelected(card, false);

      // Update price display
      const priceEl = card.querySelector('[data-upsell-price]');
      const compareEl = card.querySelector('.upsell-popup__compare-price');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        const hasCompare = opt.dataset.comparePrice && opt.dataset.comparePrice !== opt.dataset.price;
        compareEl.textContent = hasCompare ? opt.dataset.comparePrice : '';
        compareEl.hidden = !hasCompare;
        priceEl && priceEl.classList.toggle('upsell-popup__price--sale', hasCompare);
      }
    }

    /* ── Confirm: add selected upsells, then submit original form ── */
    async _handleConfirm(btn) {
      const selectedCards = [...this.querySelectorAll('[data-upsell-card][aria-checked="true"]')];



      // Check if a real product is selected
      const hasRealSelection = selectedCards.some(card => card.dataset.variantId && card.dataset.variantId.trim() !== '');

      if (!hasRealSelection) {
        // If 0 cards or only dummy card is selected, it means "no sleeve". Just close and add main product!
        this._closeAndSubmit();
        return;
      }

      // Mobile 2-step routing
      if (window.innerWidth <= 749 && this.dialog.dataset.step === '1') {
        this.dialog.dataset.step = '2';
        
        // Auto-focus receiver message on step 2
        const firstInput = this.querySelector('.upsell-popup__field-textarea');
        if (firstInput) setTimeout(() => firstInput.focus(), 50);
        return;
      }

      // If bypassing to submit on desktop, we just continue normally to add API logic


      const textEl = btn.querySelector('.upsell-popup__confirm-btn-text');
      const loadingEl = btn.querySelector('.upsell-popup__add-btn-loading');

      if (selectedCards.length > 0) {
        btn.disabled = true;
        if (textEl) textEl.hidden = true;
        if (loadingEl) loadingEl.hidden = false;

        try {
          // Generate a unique bundle ID for this cart addition sequence
          const bundleId = Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
          this.dialog.dataset.bundleId = bundleId;

          // Get values of global inputs
          const globalInputs = this.querySelectorAll('.upsell-popup__custom-fields [data-property-name]');

          // Add all selected upsells in parallel
          await Promise.all(selectedCards.map((card) => {
            const variantId = card.dataset.variantId;
            if (!variantId) return Promise.resolve();
            const fd = new FormData();
            fd.append('id', variantId);
            fd.append('quantity', '1');

            // Apply custom fields as properties
            globalInputs.forEach(input => {
              if (input.value && input.value.trim() !== '') {
                fd.append(`properties[${input.dataset.propertyName}]`, input.value.trim());
              }
            });

            // Automatically pass the parent product context
            const linkedLabel = this.dialog.dataset.linkedLabel;
            if (linkedLabel && linkedLabel.trim() !== '') {
              const mainTitle = this.dialog.dataset.mainTitle;
              const fallBackTitle = document.querySelector('h1') ? document.querySelector('h1').innerText.trim() : 'Onbekend product';
              fd.append(`properties[${linkedLabel}]`, mainTitle || fallBackTitle);
            }

            // Append internal tracking properties
            fd.append('properties[_bundle_id]', bundleId);
            fd.append('properties[_is_upsell]', 'true');

            return this._addToCart(fd);
          }));
        } catch (err) {
          console.error('[UpsellPopup] Error adding upsells:', err);
        } finally {
          btn.disabled = false;
          if (textEl) textEl.hidden = false;
          if (loadingEl) loadingEl.hidden = true;
        }
      }

      this.dialog.close();
      this._submitPendingForm();
    }

    /* ── Cart AJAX ── */
    async _addToCart(formData) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || `HTTP ${res.status}`);
      }
      return res.json();
    }
  }

  if (!customElements.get('upsell-popup-component')) {
    customElements.define('upsell-popup-component', UpsellPopupComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
